import React, { useMemo } from 'react';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridTextSorter } from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import PropTypes from 'prop-types';
import { Spinner } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';

const PermissionsTable = ({ permissions, onDelete }) => {
  const { t } = useTranslation();
  const idTextFilterProps = useDataGridTextFilter('id');
  const nameTextFilterProps = useDataGridTextFilter('name');

  const columns = useMemo(
    () => [
      {
        title: t('#ID'),
        dataIndex: 'id',
        ellipsis: true,
        sorter: dataGridTextSorter('id'),
        ...idTextFilterProps,
      },
      {
        title: t('Názov'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        ...nameTextFilterProps,
      },
    ],
    [idTextFilterProps, nameTextFilterProps, t],
  );

  if (!permissions) {
    return <Spinner />;
  }

  return (
    <>
      <DataGrid
        rowKey={(permission) => permission.id}
        columns={columns}
        dataSource={permissions || []}
        permissionsBasic={'permissions'}
        uniqueTableId={'permissions-table'}
      />
    </>
  );
};

PermissionsTable.propTypes = {
  permissions: PropTypes.array,
  onDelete: PropTypes.func,
  onCreateClick: PropTypes.func,
};

export default PermissionsTable;
